module.exports = __webpack_public_path__ + "static/media/new_CUBE_BIG_new2.95c9b360.svg";